import { FC } from "react";
import {
  Button,
  Container,
  Flex,
  Grid,
  Heading,
  Spinner,
} from "@radix-ui/themes";
import SingleNewsCard from "@/features/news/components/overview/SingleNewsCard";
import { useTenantNews } from "@/features/news/hooks/useTenantNews";
import { Zones } from "@/models/database/zones/Zones.model";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";

interface SingleZoneNewsProps {
  zone: Zones;
}

export const SingleZoneNews: FC<SingleZoneNewsProps> = ({
  zone,
}): JSX.Element => {
  const navigate = useNavigate();
  const { data, loading, error } = useTenantNews();

  const sortedData = data?.slice().sort((a, b) => {
    const dateA = a.created.toDate();
    const dateB = b.created.toDate();
    return dateB.getTime() - dateA.getTime();
  });

  const news = sortedData?.filter((news) => news.zone === zone.slug);

  const lastThreeArticles = news?.slice(0, 3);
  const hasMoreThanThree = news && news.length > 3;

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <Container px={{ initial: "4", md: "2", xl: "0" }}>
      <Heading>Latest news</Heading>
      <Grid columns={{ initial: "1", lg: "3" }} gap="5">
        {lastThreeArticles.map((item, index) => {
          const slug = `${siteRoutes["zone"]}${item.zone}${siteRoutes["newsAndSlug"]}${item.slug}`;
          return (
            <SingleNewsCard
              key={index}
              slug={slug}
              title={item.title}
              imageURL={item.imageURL}
              isFeatured={item.isFeatured}
              author={item.author}
              created={item.created}
              isFavoriteByCurrentUser={false}
              intro={item.intro}
              keywords={[]}
              zone={item.zone}
            />
          );
        })}
      </Grid>
      {hasMoreThanThree && (
        <Flex justify="center" mt="5">
          <Button
            onClick={() =>
              navigate(`${siteRoutes["zone"]}${zone.slug}${siteRoutes["news"]}`)
            }
          >
            View more articles
          </Button>
        </Flex>
      )}
    </Container>
  );
};
